import { useNavigate } from "react-router";

export default function GriSupplierReportData({ data }) {

    const navigate = useNavigate();

    const handleClick = (id) => {
        const routes = `/grisupplierreportdetails`;
        navigate(routes, { state: id });
    };
    return (
        <>
            {
                data && data.length > 0 ? (
                    data.map((curData => {
                        const { id, seller, year, createdAt } = curData;
                        return (
                            <tr className='clickablerow'
                                key={id}
                                onClick={() => handleClick(id)}>
                                <td >{seller}</td>
                                <td >{year}</td>
                                <td >{createdAt}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No Gri supplier reports data available.</span>
                )
            }
        </>
    )
}